import mapMarker from '../../assets/icons/location-marker.png';
import { t } from 'i18next';
import { IGameRules } from '../components/Modals/RulesModal/RulesModal';
import HippoMoodeCalm from '../../assets/illustration/hippo-moodes/hippo-moode-calm.png';
import HippoMoodeDreamer from '../../assets/illustration/hippo-moodes/hippo-moode-dreamer.png';
import HippoMoodeGifts from '../../assets/illustration/hippo-moodes/hippo-moode-gifts.png';
import HippoMoodeHappy from '../../assets/illustration/hippo-moodes/hippo-moode-happy.png';
import HippoMoodeHeadphones from '../../assets/illustration/hippo-moodes/hippo-moode-headphones.png';
import HippoMoodeHood from '../../assets/illustration/hippo-moodes/hippo-moode-hood.png';
import HippoMoodeProfile from '../../assets/illustration/hippo-moodes/hippo-moode-profile.png';
import HippoMoodeScooter from '../../assets/illustration/hippo-moodes/hippo-moode-scooter.png';
import HippoMoodeSkateboard from '../../assets/illustration/hippo-moodes/hippo-moode-skateboard.png';
import HippoMoodeSurf from '../../assets/illustration/hippo-moodes/hippo-moode-surf.png';
import HippoMoodeWine from '../../assets/illustration/hippo-moodes/hippo-moode-wine.png';
import HippoMoodeCute from '../../assets/illustration/hippo-moodes/hippo-moode-сute.png';
import HippoMoodeWithPhone from '../../assets/illustration/hippo-moodes/hippo-moode-with-phone.png';
import HippoMoodeCleaning from '../../assets/illustration/hippo-moodes/hippo-moode-cleaning.png';
import HippoMoodeSinging from '../../assets/illustration/hippo-moodes/hippo-moode-singing.png';
import HippoMoodeUpset from '../../assets/illustration/hippo-moodes/hippo-moode-upset.png';
import HippoMoodeWriting from '../../assets/illustration/hippo-moodes/hippo-moode-writing.png';

export const GOOGLE_MAP_API_KEY = import.meta.env.VITE_GOOGLE_MAP_API_KEY;
export const API_URL = import.meta.env.VITE_API_URL;
export const WORLD_MAP_CENTER = {
  lat: 47.5162,
  lng: 14.5501,
};
export const MAP_MARKER = mapMarker;

export const LOCAL_STORAGE_TELEGRAM_INIT_DATA_KEY =
  'LOCAL_STORAGE_TELEGRAM_INIT_DATA_KEY';

export const TELEGRAM_BASE_SHARE_URL = 'https://t.me/share/url';

export const PRELOAD_APP_MEDIA_TIMEOUT_MS = 30000;

export const SUI_ADDRESS_REGEXP = /^0[xX][a-fA-F0-9]{64}$/;

export const darkMapStyle = [
  {
    elementType: 'geometry',
    stylers: [{ color: '#1d2c4d' }],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#4b6878' }],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#64779e' }],
  },
  {
    featureType: 'administrative.neighborhood',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#4b6878' }],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#334e87' }],
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry',
    stylers: [{ color: '#023e58' }],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{ color: '#283d6a' }],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#6f9ba5' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{ color: '#304a7d' }],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#98a5be' }],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#1d2c4d' }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#0e1626' }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#4e6d70' }],
  },
];

export const WORLD_MAP_ZOOM = 3;

export const competitionModeRules: IGameRules[] = [
  {
    title: t('game.check_out_panorama'),
    text: t('game.move_around_panorama'),
  },
  {
    title: t('game.use_map_guess_location'),
    text: t('game.indicate_closest_location'),
  },
  {
    title: t('game.choose_wisely'),
    text: t('game.you_have_attempts', { attempts: '5' }),
  },
  {
    title: t('game.scoring'),
    text: t('game.score_formula'),
  },
];

export const generalModeRules: IGameRules[] = [
  {
    title: t('game.check_out_panorama'),
    text: t('game.move_around_panorama'),
  },
  {
    title: t('game.use_map_guess_location'),
    text: t('game.indicate_closest_location'),
  },
  {
    title: t('game.choose_wisely'),
    text: t('game.you_have_attempts', { attempts: '100' }),
  },
  {
    title: t('game.get_additional_attempts'),
    text: t('game.free_attempt'),
  },
  {
    title: t('game.scoring'),
    text: t('game.score_formula'),
  },
];

export const trainingModeRules: IGameRules[] = [
  {
    title: t('game.check_out_panorama'),
    text: t('game.move_around_panorama'),
  },
  {
    title: t('game.use_map_guess_location'),
    text: t('game.indicate_closest_location'),
  },
  {
    title: t('game.unlimited_training_mode'),
    text: t('game.you_have_no_limit'),
  },
];

export const hippoMoods = [
  { src: HippoMoodeCalm, size: { width: 90, height: 100 } },
  { src: HippoMoodeDreamer, size: { width: 100, height: 72 } },
  { src: HippoMoodeGifts, size: { width: 110, height: 110 } },
  { src: HippoMoodeHappy, size: { width: 120, height: 120 } },
  { src: HippoMoodeHeadphones, size: { width: 140, height: 140 } },
  { src: HippoMoodeHood, size: { width: 100, height: 100 } },
  { src: HippoMoodeProfile, size: { width: 100, height: 100 } },
  { src: HippoMoodeScooter, size: { width: 120, height: 120 } },
  { src: HippoMoodeSkateboard, size: { width: 120, height: 120 } },
  { src: HippoMoodeSurf, size: { width: 120, height: 130 } },
  { src: HippoMoodeWine, size: { width: 110, height: 110 } },
  { src: HippoMoodeCute, size: { width: 130, height: 90 } },
  { src: HippoMoodeWithPhone, size: { width: 93, height: 115 } },
  { src: HippoMoodeCleaning, size: { width: 100, height: 130 } },
  { src: HippoMoodeSinging, size: { width: 220, height: 130 } },
  { src: HippoMoodeUpset, size: { width: 100, height: 140 } },
  { src: HippoMoodeWriting, size: { width: 100, height: 130 } },
];
